import {
    Box,
    Button,
    Typography,
    Paper,
    Avatar,
    Chip,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import {
    PersonAdd,
    AutoAwesome,
    Speed,
} from '@mui/icons-material';

interface UserActionsProps {
    onAddUserClick: () => void;
    canAddUser?: boolean;
}

const UserActions: React.FC<UserActionsProps> = ({ onAddUserClick, canAddUser = true }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            {/* Premium Action Buttons Section - Kart listesi ile aynı stil */}
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 2, sm: 3 },
                    margin:{xs:0, sm:'0 20px'},
                    borderRadius: 3,
                    background: 'rgba(255,255,255,0.7)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(226, 232, 240, 0.8)',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center',  }}>
                        <Avatar sx={{
                            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                            mr: 2,
                            width: 40,
                            height: 40
                        }}>
                            <AutoAwesome />
                        </Avatar>
                        <Box>
                            <Typography variant="h5" sx={{
                                color: '#1a202c',
                                fontWeight: 700,
                                mb: 0.5,
                                fontSize: '18px !important'
                            }}>
                                Kullanıcı Yönetimi
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#64748b' }}>
                                Tüm kullanıcı operasyonlarınızı tek yerden yönetin
                            </Typography>
                        </Box>
                    </Box>
                    {!isMobile && (
                        <Chip
                            icon={<Speed />}
                            label="Hızlı İşlem"
                            sx={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                color: 'white',
                                fontWeight: 600,
                                px: 2,
                                '& .MuiChip-icon': { color: 'white' }
                            }}
                        />
                    )}
                </Box>

                {/* Action Buttons Section */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2
                }}>
                    {canAddUser && (
                        <Button
                            variant="contained"
                            startIcon={<PersonAdd />}
                            onClick={onAddUserClick}
                            sx={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                color: 'white',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                textTransform: 'none',
                                borderRadius: 2,
                                px: { xs: 2, sm: 3 },
                                py: 1.2,
                                flexShrink: 0,
                                boxShadow: '0 4px 12px rgba(30, 60, 114, 0.3)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #1a3366 0%, #245082 100%)',
                                    boxShadow: '0 6px 20px rgba(30, 60, 114, 0.4)',
                                    transform: 'translateY(-1px)'
                                },
                                transition: 'all 0.3s ease'
                            }}
                        >
                            Yeni Kullanıcı Ekle
                        </Button>
                    )}
                    {!canAddUser && (
                        <Box sx={{
                            color: '#6b7280',
                            fontSize: '0.9rem',
                            fontStyle: 'italic'
                        }}>
                            Kullanıcı ekleme yetkiniz bulunmamaktadır.
                        </Box>
                    )}
                </Box>
            </Paper>
        </Box>
    );
};

export default UserActions;
